<template>
    <v-container fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="12" lg="10" xl="6">
                <PatientConsentTable/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import PatientConsentTable from "../components/patientConsent/PatientConsentTable";

    export default {
        components: {
            PatientConsentTable
        },
        data: () => ({}),
    }
</script>
